import { OPEN_SOURCE_PROJECTS } from "../../data/openSource"
import { ContentSection } from "../layout/ContentSection"
import { Link } from "../ui/Link"
import { LinkIcon } from "../ui/LinkIcon"
import { Typography } from "@mui/material"

// "downloads/month)" is one unbroken token to the line breaker, so a row that
// doesn't quite fit shoves the whole token to its own line — and justify then
// stretches the leftover words with big gaps. A zero-width space after the
// slash gives the renderer a break point ("downloads/" / "month)") with no
// visual change, keeping word spacing natural on wrapped rows
const breakableStats = (monthlyDownloads: string) => monthlyDownloads.replace("/", "/​")

export const OpenSource = () => (
    <ContentSection title="Open Source">
        {OPEN_SOURCE_PROJECTS.map((project) => (
            <Typography key={project.name} variant="body1">
                {/* subtitle1 matches SectionItemTitle (job titles, degrees) so
                    a project name reads as its row's title, not heavy text */}
                <Link
                    href={project.href}
                    variant="subtitle1"
                    sx={{ fontWeight: 600, color: "text.primary" }}
                >
                    {project.name}
                    <LinkIcon />
                </Link>
                : {project.pitch} ({project.stars ? `${project.stars}, ` : ""}
                {breakableStats(project.monthlyDownloads)})
            </Typography>
        ))}
    </ContentSection>
)
